module.exports = __webpack_public_path__ + "static/img/s36.53be1268.png";